import { render, staticRenderFns } from "./CalculatePriceBlock.vue?vue&type=template&id=5b71aa52&scoped=true&"
import script from "./CalculatePriceBlock.vue?vue&type=script&lang=js&"
export * from "./CalculatePriceBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71aa52",
  null
  
)

export default component.exports